export default __webpack_public_path__ + "static/media/4giveslogo.a664488f.png";